import {
  navItem,
  asset,
  textEditor,
  bannerSidebar,
  productListing,
  seo,
} from './common'
import { flexContent } from './blocks'

// Global fields
export const groqGlobal = `{..., logo{...}, cardImages{..., images[]{...}}, fixedRouteSeo[]{..., shareImage{..., ${asset}}}}`

// Settings fields
export const groqSettings = `{..., branchesPage->{title, slug}, shareImage{..., ${asset}}}`

// Navigation
export const groqNavigation = `{..., items[]{${navItem}, childItems[]{${navItem}, childItems[]{${navItem}, childItems[]{${navItem}}}}, featuredItems[]{..., "slug": page->slug.current}}}`

// Home
export const groqHome = `{..., ${flexContent}}`

// Pages
export const groqPage = `{..., parent->{title}, ${seo}, ${flexContent}}`

// Product documents
export const groqProductDocuments = `{_id, title, documentType, "source": coalesce(source, "file"), url, "file": file.asset->{url, originalFilename}, products[]{name, stockCode}, keywords}`

// Product documents page heading area
export const groqProductDocumentsPage = `{title, intro, noticeTitle, noticeText, ${seo}}`

// Branches
export const groqBranch = `{..., ${seo}, content[]{${textEditor}}}`

// Branches
export const groqBranchs = `{..., seo{..., shareImage{..., ${asset}}}}`

// Tiktok Lister
export const groqTikTokLister = ({
  offset = 12,
  category,
}: {
  offset: number
  category?: string | null
}) => {
  return `{"tiktoks": *[_type == "tiktok" ${category}] | order(orderRank asc)[0...${offset}]{...,categories[]->{_id,title,slug}},"count": count(*[_type == "tiktok" ${category}]),"categories": *[_type == "tiktokCategories" &&_id in *[_type == "tiktok" && defined(categories)].categories[]._ref] | order(lower(title) asc){_id,title,slug}}`
}

// Blog Lister
export const groqBlogLister = ({
  offset = 9,
  conceptId,
}: {
  offset: number
  conceptId?: string
}) => {
  if (conceptId) {
    return `{"blogs": *[_type == "blog" && "${conceptId}" in categories[]._ref] | order(_createdAt desc)[0...${offset}]{..., slugCategory->{title, slug}}, "count": count(*[_type == "blog" && "${conceptId}" in categories[]._ref])}`
  } else {
    return `{"blogs": *[_type == "blog"] | order(_createdAt desc)[0...${offset}]{..., slugCategory->{title, slug}}, "count": count(*[_type == "blog"])}`
  }
}

// blog single
export const groqBlogSingle = `{..., ${seo}, ${flexContent}, ${bannerSidebar}, categories[]->{..., pageReference->{title, slug}}, relatedPosts[]->{title, slug, slugCategory->{title, slug}, excerpt, image}}`

// Categories
export const groqCategories = `{..., ${seo}, ${flexContent}, content[]{${textEditor}}, ${productListing}, parent->{...}}`

// All products page
export const groqAllProducts = `{..., ${seo}, ${productListing}}`

// All products page
export const groqHireBuy = `{..., ${seo}, listingSeo{..., shareImage{..., ${asset}}, redirect{..., page->{slug, title}}}, ${flexContent}, ${productListing}}`

// Product enrichment
export const groqProductEnrichment = `{faqs[]->{..., answer[]{${textEditor}}}, blogPosts[]->{..., slugCategory->{title, slug}}}`
